<template>
  <div class="privacy-manage">
    <!-- 产品隐私管理指南 start -->
    <Management-guide></Management-guide>
    <!-- 产品隐私管理指南 end -->
    <!-- 隐私问题反馈 start -->
    <!-- <Problem-feedback></Problem-feedback> -->
    <!-- 隐私问题反馈 end -->
  </div>
</template>

<script>
  import ManagementGuide from './ManagementGuide.vue';
  export default {
    // 隐私管理入口
    name: 'privacyManage-index',
    components: { ManagementGuide }
  };
</script>
